import { render, staticRenderFns } from "./EditUserServiceForm.vue?vue&type=template&id=27c4e39b&scoped=true&"
import script from "./EditUserServiceForm.vue?vue&type=script&lang=js&"
export * from "./EditUserServiceForm.vue?vue&type=script&lang=js&"
import style0 from "./EditUserServiceForm.vue?vue&type=style&index=0&id=27c4e39b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c4e39b",
  null
  
)

export default component.exports